module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-portal-1.6643e67c.svg";